import { render, staticRenderFns } from "./clientfeedback-dialog.vue?vue&type=template&id=3ff77b22&"
import script from "./clientfeedback-dialog.vue?vue&type=script&lang=js&"
export * from "./clientfeedback-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "clientfeedback-dialog.vue"
export default component.exports